export class ReactiveMap<K, V> extends Map<K, V> {
    private readonly subscribers: (() => void)[] = [];
    private scheduledNotify = false;

    subscribe(subscriber: () => void): () => void {
        this.subscribers.push(subscriber);
        return () => {
            const idx = this.subscribers.indexOf(subscriber);
            if (idx !== -1) {
                this.subscribers.splice(idx, 1);
            }
        };
    }

    delete(key: K): boolean {
        const result = super.delete(key);
        if (result) {
            this.notify();
        }

        return result;
    }

    set(key: K, value: V): this {
        if (super.has(key) && super.get(key) === value) return this;

        super.set(key, value);
        this.notify();

        return this;
    }

    clear() {
        const notify = this.size > 0;
        super.clear();
        if (notify) {
            this.notify();
        }
    }

    private notify() {
        if (this.scheduledNotify) return;

        this.scheduledNotify = true;
        setTimeout(() => {
            this.scheduledNotify = false;
            this.subscribers.forEach(subscriber => subscriber());
        });
    }
}
